import { GetterTree } from "vuex";
import { DataState } from "./types";
import { RootState } from "../../types";
// import _, { Dictionary } from "lodash";
// import { api } from "./index";
import moment from "moment";

// import { getterNs, actionNs } from "@/utils/VuexHelper";
import { nullable } from "@/common/types";
// import { nullable, tt2str } from "../../../../common/types/common";

const getRandomData = "getRandomData";
const getRawData = "getRawData";

const n = {
  getRandomData,
  getRawData
};

function getRandomInt() {
  return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
}

/**
 * Returns the raw data
 */
const getterTree: GetterTree<DataState, RootState> = {
  [n.getRawData](state): any {
    return state.rows || [];
  },

  [n.getRandomData](state, getters, rootState, rootGetters): any {
    return {
      labels: [getRandomInt(), getRandomInt()],
      datasets: [
        {
          label: "Data One",
          backgroundColor: "#f87979",
          data: [getRandomInt(), getRandomInt()]
        },
        {
          label: "Data One",
          backgroundColor: "#f87979",
          data: [getRandomInt(), getRandomInt()]
        }
      ]
    };
  }
};

export { n as getterNames, getterTree as getters };
